import ServicePageShell from "@/components/site/ServicePageShell";
export default function AssurancesPro() { return <ServicePageShell slug="assurances-pro" />; }
